var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-4 text-lg max-w-lg"},[_vm._v("\n  "+_vm._s(_vm.subTitle)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }